const PrivacyPolicy = () => {
  return (
    <section className="privacy-policy">
      <h1>Privacy Policy</h1>
      <p>Last Updated: February 17, 2026</p>

      <h2>What We Collect</h2>
      <p>
        We collect your name, email address, IP address, and cookies when you
        sign up.
      </p>

      <h2>How We Collect It</h2>
      <p>
        Information is collected through our sign-up form and automatically via
        cookies when you visit our site.
      </p>

      <h2>Why We Collect It</h2>
      <p>
        We use your information to improve our site experience and to send you
        emails about updates and relevant content.
      </p>

      <h2>Who We Share It With</h2>
      <p>
        We may share your data with trusted advertising partners to serve
        relevant ads to you. We also use Google AdSense, which may use cookies
        to show ads based on your browsing activity. You can learn more at{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noreferrer"
        >
          Google's Privacy Policy
        </a>
        .
      </p>

      <h2>Cookies</h2>
      <p>
        We use cookies to enhance your experience on our site. You can choose to
        disable cookies through your browser settings, though this may affect
        site functionality.
      </p>

      <h2>Your Rights</h2>
      <p>
        You can request to view, update, or delete your personal data at any
        time by contacting us.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about this privacy policy, please reach out to
        us at <a href="mailto:Chesswizzania@gmail.com">Chesswizzania@gmail.com</a>.
      </p>
    </section>
  );
};

export default PrivacyPolicy;